package one.healthium.fodmap.presentation.navigation.health_tools

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.health_tools.ui.HealthToolsScreen

@Composable
fun HealthToolsContent(component: HealthToolsComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        HealthToolsScreen(component)
    }
}